import React from 'react';
import dayjs from 'dayjs';
import Tooltip from 'antd/es/tooltip';
import { Table } from 'shared/ui/table';
import { EyeIcon } from 'shared/ui/icons';
import useWindowDimensions from 'shared/hooks/useWindowDimensions';
import { useBukuTarifLogList } from '../../hooks/useBukuTarifLogList';

const columns = [
  {
    key: 'organization_name',
    label: 'Nama',
    align: 'text-left',
    isSortable: true,
  },
  {
    key: 'starting_date',
    label: 'Starting Date',
    align: 'text-left',
    classCell: 'text-nowrap',
    isSortable: true,
  },
  {
    key: 'actions',
    label: '',
    align: 'text-right',
    classCell: 'sticky-cell flex justify-end',
    classHead: 'sticky-cell-head w-14',
  },
];

const SearchIcon = (
  <svg
    className="w-5 h-5 text-gray-500"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1115 3.5a7.5 7.5 0 011.65 14.15z"
    />
  </svg>
);

function LogListPanel() {
  const {
    data,
    isFetching,
    pageSize,
    navigate,
    handlePageSizeChange,
    handlePaginationChange,
    handleSortOrderChange,
    handleSearchChange,
  } = useBukuTarifLogList();

  const { isMobile } = useWindowDimensions();

  const rows =
    data?.data?.map((item) => ({
      starting_date: dayjs(item?.starting_date).format('DD MMM YYYY'),
      organization_name: (
        <Tooltip placement="bottom" title={item?.organization_name}>
          <div className="w-auto">{item?.organization_name}</div>
        </Tooltip>
      ),
      actions: (
        <span
          className="cursor-pointer"
          onClick={() => navigate(`/buku-tarif-log/super-admin/${item?.id}`)}
          role="button"
          aria-label={`View detail for ${item?.organization_name}`}
        >
          <EyeIcon color="#6b7280" />
        </span>
      ),
    })) || [];

  return (
    <>
      <div className="w-full bg-white border rounded-lg flex flex-wrap p-4">
        <div className="w-full flex flex-wrap justify-between flex-col-reverse md:flex-row gap-4">
          <div
            className={`flex items-center ${isMobile ? 'flex-col-reverse flex-col w-full' : ''}`}
          >
            <div className="relative">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                {SearchIcon}
              </div>
              <input
                type="text"
                className={`${isMobile ? 'w-full' : ''} pl-10 pr-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500`}
                placeholder="Search"
                onChange={handleSearchChange}
              />
            </div>
          </div>
          <div className="w-full mt-6">
            <Table
              data={rows}
              columns={columns}
              pageSize={pageSize}
              page={data?.meta?.page}
              total={data?.meta?.total}
              limit={data?.meta?.limit}
              loading={isFetching}
              handlePageSizeChange={handlePageSizeChange}
              handlePaginationChange={handlePaginationChange}
              handleSortOrderChange={handleSortOrderChange}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default LogListPanel;
